import { gsap } from 'gsap';
import { MorphSVGPlugin } from 'gsap/MorphSVGPlugin';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { SplitText } from 'gsap/SplitText';

gsap.registerPlugin(MorphSVGPlugin, ScrollTrigger, SplitText)

ScrollTrigger.normalizeScroll(true)
ScrollTrigger.config({ ignoreMobileResize: true })

export * from 'gsap'
export { MorphSVGPlugin, ScrollTrigger, SplitText }

window.addEventListener('bodyResize', ScrollTrigger.refresh)
